export function extractErrorMsg(error: unknown, defaultMsg?: string) {
  if (error instanceof Error) {
    return tryParseJson(error.message);
  }

  if (error instanceof Response) {
    return `${error.statusText} (${error.status})`;
  }

  return defaultMsg ?? 'Something went wrong, please try again.';
}

function tryParseJson(errorMessage: string) {
  try {
    const parsed: unknown = JSON.parse(errorMessage);
    if (parsed && typeof parsed === 'object') {
      const object = parsed as Record<string, unknown>;
      if (typeof object.message === 'string' && object.message.length > 0) {
        return object.message;
      }
    }
  } catch {
    return errorMessage;
  }
}
